<script setup>
import { nl } from '@nuxt/ui/locale'
const toaster = { position: 'bottom-center' }
</script>

<template>
    <UApp :toaster="toaster" :locale="nl">
        <slot></slot>
    </UApp>
</template>
